export default "__VITE_ASSET__BLTxVUAz__"